import { Badge } from "@getgreenline/blaze-ui";
import type { ComponentProps } from "react";
import type { CampaignStatus } from "@/services/campaigns.service";
import { getCampaignStatusLabel } from "@/utils/campaigns";

type BadgeVariant = ComponentProps<typeof Badge>["variant"];

type CampaignStatusBadgeProps = Omit<
  ComponentProps<typeof Badge>,
  "children" | "variant"
> & {
  status: CampaignStatus;
};

const campaignStatusBadgeVariants: Record<CampaignStatus, BadgeVariant> = {
  DRAFT: "secondary",
  ACTIVE: "default",
  PAUSED: "destructive",
  ARCHIVED: "outline",
  SCHEDULED: "secondary",
  ENDED: "soft",
  OUTOFBUDGET: "destructive",
};

export function CampaignStatusBadge({
  status,
  ...props
}: CampaignStatusBadgeProps) {
  return (
    <Badge
      variant={campaignStatusBadgeVariants[status] || "outline"}
      {...props}
    >
      {getCampaignStatusLabel(status)}
    </Badge>
  );
}
